import { render, staticRenderFns } from "./SystemSetting_Default.vue?vue&type=template&id=5652072a&"
import script from "./SystemSetting_Default.vue?vue&type=script&lang=js&"
export * from "./SystemSetting_Default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports